import { IconAlarm } from 'components/Icons'
import { IconAlarm2 } from 'components/Icons'
import React from 'react'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

interface ButtonAlarmProps {
  onClick?: (e: React.MouseEvent) => void
  close?: boolean
  buttonType?: 'feed' | 'list'
  //알람 타입 추가
  isAlarm?: boolean
  className?: string
}

const ButtonAlarm: React.FC<ButtonAlarmProps> = (props) => {
  const { className, buttonType = 'feed', isAlarm = false, onClick } = props
  const { t } = useTranslation()
  return (
    <StyledButtonAlarm
      className={className}
      onClick={onClick}
      buttonType={buttonType}
      isAlarm={isAlarm}
      title={isAlarm ? t('alarm_receiving') : t('alarm_receive')}
    >
      {isAlarm ? <IconAlarm2 /> : <IconAlarm />}
      {buttonType === 'feed' && <span>{isAlarm ? t('alarm_receiving') : t('alarm_receive')}</span>}
    </StyledButtonAlarm>
  )
}

const StyledButtonAlarm = styled.button<ButtonAlarmProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  width: ${(props) => (props.buttonType === 'feed' ? '90px' : '28px')};
  height: 28px;
  padding: ${(props) => (props.buttonType === 'feed' ? '0 10px' : '6px')};
  border: 1px solid #ff2d55;
  background: ${({ isAlarm }) => (isAlarm ? '#FF2D55' : '#fff')};
  border-radius: 14px;
  color: ${({ isAlarm }) => (isAlarm ? '#fff' : '#FF2D55')} !important;
  z-index: 10;
  cursor: pointer;
  font-size: 12px;
  line-height: 1;
  path {
    fill: ${(props) => (props.isAlarm ? '#fff' : '#FF2D55')};
  }
  white-space: nowrap;
`
export default ButtonAlarm
